import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';

export class ConsumerApiService {
	static getPickupOrder(orderNumber, zipCode, storeNumber) {
		return trackPromise(
			axios.get(
				`${window.location.href.replace(window.location.search, '')}getpickuporder?orderNumber=${orderNumber}&zipCode=${zipCode}&storeNumber=${storeNumber}`
			)
		);
	}

	static notifyByWebsite(orderNumber, zipCode, storeNumber, details, located, placement, type, pickedUpBy) {
		return trackPromise(
			axios.post(
				`${window.location.href.replace(window.location.search, '')}notifybywebsite`, {
					orderNumber: orderNumber,
					zipCode: zipCode,
					storeNumber: storeNumber,
					details: details,
                    located: located,
                    placement: placement ? placement : null,
					type: type,
					pickedUpBy: pickedUpBy
				}
			)
		);
	}

	static extendPickupOrder(orderNumber, zipCode, channel, storeNumber) {
		return trackPromise(
			axios.get(
				`${window.location.href.replace(window.location.search, '')}extendpickuporder?orderNumber=${orderNumber}&zipCode=${zipCode}&channel=${channel}&storeNumber=${storeNumber}`
			)
		);
	}
}
